import React, { Component } from 'react';
import classNames from 'classnames';
import FontAwesome from 'react-fontawesome';


class Toggle extends Component {


	constructor(props) {
		super(props)
		this.state = {toggled: this.props.toggled}
	}

	ToggleClick = (e) => {
		this.props.onChange(!this.state.toggled) 
		this.setState({toggled: !(this.state.toggled)});
	}

	ToggleContent = (props) => {

		let toggleClass = classNames({
			'on': this.state.toggled,
			'toggle': true
		}) 
		return <div className={toggleClass} onClick={this.ToggleClick}><div className="toggle-inner"></div></div>
	}

	render(props) {

		let wrapClass = classNames({
			'do-half': this.props.doHalf,
			'control-wrap': true,
			'toggle-wrap': true
		})

		return (
			<div className={wrapClass}>
				<span className="control-label">
				{this.props.icon && <FontAwesome name={this.props.icon} />}&nbsp;{this.props.name}
				</span>
				{ this.ToggleContent({onClick:this.props.onChange}) }
			</div>
		)
	}
}

export default Toggle


// WEBPACK FOOTER //
// ./src/controls/Toggle.jsx